import { Component } from 'react';

class ObstructiveSleepApnea extends Component {
  render() {
    return <h1>Obstructive Sleep Apnea</h1>;
  }
}

export default ObstructiveSleepApnea;
